import angular from "angular";

let URLS = angular.module("URLS", []).constant(
  "URLS",
  (() => {
    "ngInject";

    const t = {};
    let PRODUCTION = "https://api.saaf.events";
    let TESTING = "http://velos-api.lefterislalos.com";
    let DOCKER = "http://127.0.0.1:8000";
    let BASE_URL = window.env.API_ENDPOINT || PRODUCTION;
    t.DEBUG = false;

    t.BASE_URL = BASE_URL;

    /* BASE URL */
    t.BASE_URL = BASE_URL;

    /* IMAGES */
    t.IMAGES_URL = BASE_URL + "/storage/images";

    /* AUTH */
    t.AUTH = BASE_URL + "/auth";
    t.LOGIN = t.AUTH + "/login/{userType}";
    t.RECOVER_PASSWORD = t.AUTH + "/recovery/{userType}";
    t.RESET_PASSWORD = t.AUTH + "/reset/{userType}";
    t.CHANGE_PASSWORD = t.AUTH + "/changePassword/{userType}";

    /* USERS */
    t.USERS = BASE_URL + "/users";

    /* TEAMS */
    t.TEAMS = BASE_URL + "/teams";
    t.MATCHES_PRINTS_ENTRIES =
      t.TEAMS + "/{teamId}/prints/teamEntries/{matchId}";
    t.TEAM_PLAYERS_CARDS = t.TEAMS + "/{teamId}/prints/players/cards";

    /* JUDGES */
    t.JUDGES = BASE_URL + "/judges";
    t.JUDGES_CARD_PDF = t.JUDGES + "/{judgeId}/card";

    /* COACHES */
    t.COACHES = BASE_URL + "/coaches";
    t.COACHES_CARD_PDF = t.COACHES + "/{coachId}/card";

    /* STAFF */
    t.STAFF = BASE_URL + "/staffs";
    t.STAFF_CARD_PDF = t.STAFF + "/{staffId}/card";

    /* TRAINERS */
    t.TRAINERS = BASE_URL + "/trainers";
    t.TRAINERS_CARD_PDF = t.TRAINERS + "/{trainerId}/card";

    /* PLAYERS */
    t.PLAYERS = BASE_URL + "/players";
    t.PLAYERS_CARD_PDF = t.PLAYERS + "/{playerId}/card";
    t.PLAYERS_TRAINING_CARD_PDF = t.PLAYERS + "/{playerId}/trainCard";
    t.MATCHES_PLAYER_QUALIFICATION =
      t.PLAYERS + "/{playerId}/prints/qualification/{matchId}";

    /* TRAINING ENTRIES */
    t.TRAINING_ENTRIES = BASE_URL + "/trainingEntries";

    /* TRAINING CENTERS */
    t.TRAINING_CENTERS = BASE_URL + "/trainingCenters";

    /* TRANSFERS */
    t.TRANSFERS = t.PLAYERS + "/transfers";

    /* LEAGUES */
    t.LEAGUES = BASE_URL + "/leagues";

    /* ROLES */
    t.ROLES = BASE_URL + "/roles";

    /* PERMISSIONS */
    t.PERMISSIONS = BASE_URL + "/permissions";

    /* MATCHES */
    t.MATCHES = BASE_URL + "/matches";

    /* MATCHES SCORING */
    t.MATCHES_ADD_SHOTS = t.MATCHES + "/{roundId}/addShots";
    t.MATCHES_ADD_SHOTS_FROM_EXCEL = t.MATCHES + "/{matchId}/addShotsFromExcel";
    t.MATCHES_CLEAR_SHOTS = t.MATCHES + "/{roundId}/clear";
    t.MATCHES_FINALIZE = t.MATCHES + "/{matchId}/finalizeQualification/{state}";

    /* MATCHES LEAGUES */
    t.MATCHES_ADD_LEAGUE = t.MATCHES + "/{matchId}/addLeague";
    t.MATCHES_REMOVE_LEAGUE = t.MATCHES + "/{matchId}/removeLeague";
    t.MATCHES_MOVE_LEAGUES = t.MATCHES + "/{matchId}/moveLeagues";

    /* MATCHES PLAYERS */
    t.MATCHES_ADD_PLAYER =
      t.MATCHES + "/{matchId}/players/{playerId}/{leagueId}/{teamId}";
    t.MATCHES_REMOVE_PLAYER = t.MATCHES + "/{matchId}/players/{playerId}";
    t.MATCHES_CHECK_IN_PLAYER =
      t.MATCHES + "/{matchId}/checkInPlayer/{playerId}";
    t.MATCHES_UPDATE_PLAYER_LEAGUE =
      t.MATCHES + "/{matchId}/updatePlayerLeague/{playerId}/{leagueId}";
    t.MATCHES_UPDATE_TEAM_INFO =
      t.MATCHES + "/{matchId}/updateTeamInformation/{teamId}";

    /* MATCHES TARGETS */
    t.MATCHES_PRODUCE_TARGETS = t.MATCHES + "/{matchId}/produceTargets";
    t.MATCHES_CLEAR_TARGETS = t.MATCHES + "/{matchId}/clearTargets";
    t.MATCHES_MOVE_TARGETS = t.MATCHES + "/{matchId}/moveTargets";
    t.MATCHES_MOVE_PLAYER_TO_TARGET =
      t.MATCHES + "/{matchId}/movePlayerToTarget/{playerId}";
    t.MATCHES_SWAP_TARGETS = t.MATCHES + "/{matchId}/swapTargets";
    t.MATCHES_SWAP_PLAYERS_TARGETS =
      t.MATCHES + "/{matchId}/swapPlayersTargets/{playerOne}/{playerTwo}";
    t.MATCHES_RESULTS = t.MATCHES + "/{matchId}/results";

    /* MATCH PRINTS */
    t.MATCHES_PRINTS = t.MATCHES + "/{matchId}/prints/{print}";
    t.MATCHES_PRINTS_ELIMINATION =
      t.MATCHES + "/{matchId}/prints/eliminations/{leagueId}/{eliminationType}";
    t.MATCHES_PRINTS_ELIMINATION_TARGET_BOARDS =
      t.MATCHES +
      "/{matchId}/prints/eliminations/{leagueId}/{eliminationType}/{round}/targetsBoards";
    t.MATCHES_PRINTS_ELIMINATION_PRODUCE_TARGETS =
      t.MATCHES +
      "/{matchId}/eliminations/{leagueId}/{eliminationType}/{round}/produceTargets";

    /* MATCHES ELIMINATION*/
    t.MATCHES_ELIMINATION =
      t.MATCHES + "/{matchId}/eliminations/{leagueId}/{eliminationType}";
    t.MATCHES_ELIMINATION_NEXT_ROUND = t.MATCHES_ELIMINATION + "/nextRound";
    t.MATCHES_ELIMINATION_UPDATE = t.MATCHES_ELIMINATION + "/{teamId}";
    t.MATCHES_ELIMINATION_ADD_SHOTS =
      t.MATCHES + "/eliminations/{matchOlympicId}/{eliminationType}/addShots";
    t.MATCHES_ELIMINATION_CLEAR_SHOTS =
      t.MATCHES + "/eliminations/{matchOlympicId}/{eliminationType}/clear";
    t.MATCHES_ELIMINATION_FORFEIT =
      t.MATCHES +
      "/eliminations/{matchOlympicId}/{eliminationType}/forfeit/{playerId}";

    /* REPORTS */
    t.REPORTS = BASE_URL + "/reports";
    t.REPORTS_STATISTICS = t.REPORTS + "/statistics/{year}/{report}";
    t.REPORTS_PAYMENTS = t.REPORTS + "/payments/{report}";

    /* PAYMENTS */
    t.PAYMENTS = BASE_URL + "/payments";
    t.PAYMENTS_RESOURCE = t.PAYMENTS + "/{resource}";
    t.PAYMENTS_SINGLE_REPORT = t.PAYMENTS + "/{resource}/report/{id}";
    t.PAYMENTS_CUSTOM_REPORT = t.PAYMENTS + "/{resource}/customReport";

    /* YEARS */
    t.YEARS = BASE_URL + "/years";

    /* STATES */
    t.STATES = BASE_URL + "/states";

    /* COUNTIES */
    t.COUNTIES = BASE_URL + "/counties";

    /* REGIONS */
    t.REGIONS = BASE_URL + "/regions";

    /* NATIONALITIES */
    t.NATIONALITIES = BASE_URL + "/nationalities";

    return t;
  })()
).name;

export default URLS;



// WEBPACK FOOTER //
// ./client/app/constants/URLS.js